<template>
    <div>
      <mdb-edge-header color="teal darken-1"/>
      <div class="container free-bird">
        <mdb-row>
          <mdb-col md="10" class="mx-auto float-none white z-depth-1 py-2 px-2">
            <mdb-card-body>
              <h3>これ何？</h3>
              <p>CSV を入力したら、何かいい感じにテーブルで表現してくれる。</p>
              <br>

              <h3>使い方は？</h3>
              <p>
                【INPUT CSV】の項目にて、テキストエリアに CSVを入力。<br>
                その後、[ CONVERT ] ボタンを押すと、【TABLE FORMAT】の項目に表示される。
              </p>
              <p>[ SET SAMPLE DATA ] を押すと、こっちで用意した適当なサンプルデータをセットします。</p>
              <br>

              <h3>注意事項</h3>
              <p>
                開発者の気分で、今後、機能が増えたり挙動が変わったりするかもしれません。<br>
                特に UI は改善の余地がありありなので、そのうち変わるかも。
              </p>
              <br>

              <h3>作った人間</h3>
              <p>
                こんな奴。→
                <a class="blue-text mr-1" href="https://twitter.com/kakisoft_tab"><mdb-icon fab icon="twitter" size="2x" /></a>
              </p>
            </mdb-card-body>
          </mdb-col>
        </mdb-row>
      </div>
    </div>
</template>

<script>
import { mdbCol, mdbRow, mdbIcon, mdbEdgeHeader, mdbCardBody } from 'mdbvue';

export default {
  name: 'HomePage',
  components: {
    mdbCol,
    mdbRow,
    mdbIcon,
    mdbEdgeHeader,
    mdbCardBody
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}

.home-feature-box {
  padding: 40px 0;
}

.home-feature-box i {
  font-size: 6rem;
}

.home-feature-box span {
  display: block;
  color: black;
  font-size: 20px;
  font-weight: bold;
  padding-top: 20px;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
}

a {
  color: #42b983;
}

</style>
